export default __webpack_public_path__ + "static/media/cinderblock-100.cdb65b85.woff2";